import Cookies from "js-cookie";

export default class LocalStorageWithFallback {

    private readonly localStorageSupported: boolean;

    public constructor() {
        this.localStorageSupported = LocalStorageWithFallback.localStorageIsSupported();
    }

    public get(key: string): string | null | undefined {
        if (this.localStorageSupported) {
            return localStorage.getItem(key);
        } else {
            return Cookies.get(key)
        }
    }

    public set(key: string, value: string): void {
        if (this.localStorageSupported) {
            localStorage.setItem(key, value);
        } else {
            Cookies.set(key, value)
        }
    }

    public remove(key: string): void {
        if (this.localStorageSupported) {
            localStorage.removeItem(key);
        } else {
            Cookies.remove(key);
        }
    }

    public getItem(key: string): string | null {
        if (!this.localStorageSupported) {
            return null;
        }

        return localStorage.getItem(key);
    }

    public setItem(key: string, value: string): void {
        if (this.localStorageSupported) {
            localStorage.setItem(key, value)
        }
    }

    private static localStorageIsSupported(): boolean {
        try {
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');
            return true;
        } catch (e) {
            return false;
        }
    }
}
